import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as config from './../../../config';
import request from '../../../utilities/request';
import { useSnackbar } from 'notistack';
import authStyles from '../authStyles';
import * as kycActions from '../../../store/kyc/kycActions';
import DataTable from '../../../components/DataTable/MuiDataTable';
import CircularProgress from '@mui/material/CircularProgress';
//import Fab from '@mui/material/Fab';
import Button from '@mui/material/Button';
//import AddIcon from '@mui/icons-material/Add';
import Overview from './Overview';
import { SignalCellularNullOutlined } from '@mui/icons-material';
import useKycShareholders from '../../../api/useKycShareholders';
import LockedTile from '../../../components/LockedTile';
import { SUBSCRIPTION_PRO } from '../../../constants/profile';
const KycPage = (props) => {
    const classes = authStyles();
    const { enqueueSnackbar } = useSnackbar();
    const [isDisabledSend, setIsDisabledSend] = useState(false);
    const [shareholderIndex, setShareholderIndex] = useState(
        SignalCellularNullOutlined
    );

    const { shareholders, shareholdersLoading, overview } = useKycShareholders();

    const fetchDomainUsers = ({ page = 1, limit = 10 }) => {
        return request
            .get(`${config.API_BASE_URL}/investors/domain-users`, {
                params: { page, per_page: limit },
            })
            .then((response) => ({
                data: {
                    data: response.data.data,
                    total: response.data.meta.total,
                },
            }))
            .catch(() => ({
                data: { data: [], total: 0 },
            }));
    };

    const sendkycInvite = (investor_id, idx) => {
        setIsDisabledSend(true);
        setShareholderIndex(idx);
        request
            .post(`${config.API_BASE_URL}/kyc/invite`, {
                investor_id: investor_id,
            })
            .then((response) => {
                enqueueSnackbar('KYC invite sent successfully', {
                    variant: 'success',
                });

                setIsDisabledSend(false);
                //props.kycActions.getKyc();
            })
            .catch((error) => {
                setIsDisabledSend(false);
            })
            .finally(() => {
                setShareholderIndex(null);
            });
    };

    return (
        <LockedTile requiredPlan={SUBSCRIPTION_PRO}>
            <div>
                { !shareholdersLoading && <Overview kyc={overview} hideHoldersTable />}

                <Grid container spacing={2} sx={{ marginTop: '8px' }}>
                    {shareholdersLoading ? (
                        <Grid container item xs={12} justifyContent="center">
                            <CircularProgress />
                        </Grid>
                    ) : (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <DataTable
                                    title={'Shareholder KYC Status'}
                                    customToolbar={() => (
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={() =>
                                                sendkycInvite('all', 'all')
                                            }
                                            disabled={
                                                shareholderIndex === 'all'
                                            }
                                            sx={{ textTransform: 'none' }}
                                        >
                                            {shareholderIndex === 'all'
                                                ? 'Sending...'
                                                : 'Invite All'}
                                        </Button>
                                    )}
                                    data={
                                        shareholders && shareholders.length > 0
                                            ? shareholders
                                            : []
                                    }
                                    columns={[
                                        {
                                            label: 'Shareholder',
                                            name: 'investor',
                                        },
                                        {
                                            label: 'Company',
                                            name: 'company_name',
                                        },
                                        {
                                            label: 'Kyc Status',
                                            name: 'kyc_status',
                                        },
                                        {
                                            label: 'Subscription Agreement',
                                            name: 'subscription_agreement',
                                            options: {
                                                customBodyRender: (value) => (
                                                    <span>
                                                        {value === 'Y'
                                                            ? 'Yes'
                                                            : 'No'}
                                                    </span>
                                                ),
                                            },
                                        },

                                        {
                                            label: 'Invite',
                                            name: 'investor_id',
                                            options: {
                                                customBodyRenderLite: (
                                                    dataIndex
                                                ) => {
                                                    const row =
                                                        shareholders[dataIndex];
                                                    return (
                                                        <Button
                                                            type="button"
                                                            variant="text"
                                                            color="primary"
                                                            className={
                                                                classes.alignCenter
                                                            }
                                                            style={{
                                                                textTransform:
                                                                    'none',
                                                            }}
                                                            onClick={() =>
                                                                sendkycInvite(
                                                                    row[
                                                                        'investor_id'
                                                                    ],
                                                                    dataIndex
                                                                )
                                                            }
                                                            disabled={
                                                                row[
                                                                    'kyc_status'
                                                                ] ===
                                                                    'Approved' ||
                                                                (isDisabledSend &&
                                                                    (shareholderIndex ===
                                                                        dataIndex ||
                                                                        shareholderIndex ===
                                                                            'all'))
                                                            }
                                                        >
                                                            {isDisabledSend &&
                                                            shareholderIndex ===
                                                                dataIndex ? (
                                                                <div className="flex-center">
                                                                    <CircularProgress
                                                                        size={
                                                                            24
                                                                        }
                                                                    />
                                                                    &nbsp;
                                                                    Sending...
                                                                </div>
                                                            ) : (
                                                                'Send KYC link'
                                                            )}
                                                        </Button>
                                                    );
                                                },
                                            },
                                        },
                                    ]}
                                    shareSort={2}
                                />
                            </Grid>
                            {props.profile?.investor_domain_host && (
                                <Grid item xs={12}>
                                    <DataTable
                                        title={'Registered Investors'}
                                        isServerSide
                                        disableServerSideControls
                                        data={fetchDomainUsers}
                                        columns={[
                                            {
                                                label: 'Investor ID',
                                                name: 'investor_id',
                                            },
                                            {
                                                label: 'Full Name',
                                                name: 'full_name',
                                            },
                                            {
                                                label: 'Email',
                                                name: 'email',
                                            },
                                            {
                                                label: 'Nationality',
                                                name: 'nationality',
                                            },
                                            {
                                                label: 'Kyc Status',
                                                name: 'kyc_status',
                                            },
                                            {
                                                label: 'Steps Completed',
                                                name: 'registration_steps_completed',
                                                options: {
                                                    customBodyRender: (
                                                        value
                                                    ) =>
                                                        value?.length > 0
                                                            ? value.join(', ')
                                                            : '',
                                                },
                                            },
                                            {
                                                label: 'Steps Skipped',
                                                name: 'registration_steps_skipped',
                                                options: {
                                                    customBodyRender: (
                                                        value
                                                    ) =>
                                                        value?.length > 0
                                                            ? value.join(', ')
                                                            : '',
                                                },
                                            },
                                        ]}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    )}
                </Grid>
            </div>
        </LockedTile>
    );
};

const mapStateToProps = ({ kyc, profile }) => {
    return {
        kyc: kyc,
        profile: profile,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        kycActions: bindActionCreators(kycActions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KycPage);
